import React, { ReactElement } from 'react';
import './Footer.scss';

export const Footer = (): ReactElement => {
  return (
    <footer className="footer">
      <div className="footer-term-list">
        <a
          href="https://everylive.jp/static/assets/terms/service_terms.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'everylive利用規約'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/streaming_terms.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'everylive配信規約'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/delivery_terms.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'everylive配信ガイドライン（オフィシャルライバー）'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/delivery_terms_noncontract.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'everylive配信ガイドライン（一般ライバー）'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/music_use.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'楽曲利用に関するガイドライン'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/privacy_policy.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'プライバシーポリシー'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/liver_management_policy.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'ライバーマネジメントポリシー'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/protective_measures.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'利⽤者保護を図るための措置に関する情報提供'}
        </a>
        &#160;|&#160;
        <a
          href="https://everylive.jp/static/assets/terms/live_commerce_guidelines.pdf"
          target="_blank"
          rel="noreferrer"
        >
          {'商品紹介及び商品売買についてのガイドライン'}
        </a>
      </div>
      <b className="footer-copyright">Copyright everylive Inc.</b>
    </footer>
  );
};
